import L from 'leaflet';

import './ClusterPoi.css';
export const createClusterCustomIcon = function (cluster) {
  const counter = cluster.getChildCount();
  let pointClassName = '';
  if(counter > 10 && counter < 100){
    pointClassName = 'marker-cluster-custom-between-10-99';
  } else if(counter > 100){
    pointClassName = 'marker-cluster-custom-more-99';
  }
  return L.divIcon({
    html: `
    <img className="red-dot" src="${require('../../../../assets/images/red-counter.svg')}" alt=""/>
    <div className="counter">${counter}</div>`,
    className: `marker-cluster-custom ${pointClassName}`,
    iconSize: L.point(40, 40, true),
  });
}